import { isNonNullable } from '@ori/ts-utils';
import { isPpaLabel } from "./isPpaLabel";
export var getPpaLabelFromGql = function getPpaLabelFromGql(labels) {
  var _labels$find;
  return (_labels$find = labels === null || labels === void 0 ? void 0 : labels.find(function (label) {
    return isNonNullable(label) && label.labelKey && isPpaLabel(label.labelKey);
  })) !== null && _labels$find !== void 0 ? _labels$find : null;
};
//# sourceMappingURL=getPpaLabelFromGql.js.map